import { apiRequest, API_BASE_URL, tokenManager } from './api';

export const notesAPI = {
    // Tüm notları (veya belirli bir klasörün çocuklarını) getir
    // Tüm notları (veya arama sonuçlarını) getir
    getNotes: async (parentId = null, searchQuery = null, type = 'private') => {
        let queryParams = [];
        if (searchQuery) {
            queryParams.push(`search=${encodeURIComponent(searchQuery)}`);
        } else {
            queryParams.push(parentId ? `parent=${parentId}` : 'parent=null');
        }
        queryParams.push(`type=${type}`);
        const query = `?${queryParams.join('&')}`;
        return await apiRequest(`/notes/${query}`);
    },

    // Tek bir notu detaylı getir (optional signal for in-flight cancellation)
    getNote: async (id, signal) => {
        const options = { method: 'GET' };
        if (signal) options.signal = signal;
        return await apiRequest(`/notes/${id}/`, options);
    },

    // Yeni not oluştur
    createNote: async (data) => {
        return await apiRequest('/notes/', 'POST', data);
    },

    // Not'tan talep oluştur
    createTicketFromNote: async (id, data = {}) => {
        return await apiRequest(`/notes/${id}/create_ticket/`, 'POST', data);
    },

    // Notu güncelle (Partial)
    updateNote: async (id, data) => {
        return await apiRequest(`/notes/${id}/`, 'PATCH', data);
    },

    // Notu sil
    deleteNote: async (id) => {
        return await apiRequest(`/notes/${id}/`, 'DELETE');
    },

    // Not yorumları
    getComments: async (noteId) => {
        return await apiRequest(`/notes/${noteId}/comments/`);
    },

    createComment: async (noteId, commentText) => {
        return await apiRequest(`/notes/${noteId}/comments/`, 'POST', { comment_text: commentText });
    },

    deleteComment: async (noteId, commentId) => {
        return await apiRequest(`/notes/${noteId}/comments/${commentId}/`, 'DELETE');
    },

    // Resim yükle
    uploadImage: async (file) => {
        const formData = new FormData();
        formData.append('image', file);

        return await apiRequest('/notes/upload-image/', 'POST', formData);
    },

    // URL ile resim yükle (Word/Web yapıştırmaları için)
    uploadImageByUrl: async (url) => {
        return await apiRequest('/notes/upload-image/', 'POST', { url });
    },

    // Word dosyası import et
    importWord: async (file) => {
        const formData = new FormData();
        formData.append('file', file);
        return await apiRequest('/notes/import-word/', 'POST', formData);
    },

    // Notu Word (.docx) olarak dışa aktar
    exportWord: async (noteId) => {
        const url = `${API_BASE_URL}/notes/${noteId}/export-word/`;
        const token = tokenManager.getAccessToken();
        const response = await fetch(url, {
            method: 'GET',
            headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        if (!response.ok) throw new Error('Word dışa aktarma başarısız');
        const blob = await response.blob();
        const contentDisposition = response.headers.get('Content-Disposition');
        let filename = 'note.docx';
        if (contentDisposition) {
            const match = contentDisposition.match(/filename="?([^";\n]+)"?/);
            if (match) filename = match[1].trim();
        }
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = filename;
        a.click();
        URL.revokeObjectURL(a.href);
    }
};
